import { render } from "./AddNewAccountForm.vue?vue&type=template&id=7b06f891"
import script from "./AddNewAccountForm.vue?vue&type=script&lang=js"
export * from "./AddNewAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__